import React, {useCallback, useState} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Input} from 'components/ui-kit/Input';
import {Modal} from 'components/ui-kit/Modal';

import {
    $invoiceLineChargeData,
    $invoiceLinesHolder,
    setInvoiceLinesHolder,
} from 'models/documents/invoices/create';
import {
    $modalDuplicateLinesModal,
    setModalDuplicateLinesModal,
} from 'models/documents/invoices/details';

import {InvocieLineHolder, InvoiceLine} from 'types/invoices';

import {ButtonWrapper} from './styled';

export const ModalDuplicateLines = () => {
    const modalDuplicateLinesModal = useStore($modalDuplicateLinesModal);
    const invoiceLinesHolder = useStore($invoiceLinesHolder);
    const invoiceLineChargeData = useStore($invoiceLineChargeData);
    const {index: lineId = -1, show: isShow, initialLineData} = modalDuplicateLinesModal;
    const {t: translation} = useTranslation();
    const GEN_INFO = 'pages.documents.invoices.modalDuplicateLines';
    const t = (key: string, vars?: Record<string, any>) =>
        translation(`${GEN_INFO}.${key}`, vars ?? {});
    const [value, setValue] = useState<number | undefined>(undefined);

    const handleCloseCallback = useCallback(() => {
        setModalDuplicateLinesModal({index: -1, show: false});
        setValue(undefined);
    }, [setModalDuplicateLinesModal]);

    const createDuplicateLine = useCallback(
        (sourceLine: InvoiceLine): InvoiceLine => ({
            description: sourceLine.description,
            isHsn: sourceLine.isHsn,
            serviceCategory: sourceLine.serviceCategory,
            qty: sourceLine.qty,
            price: sourceLine.price,
            lines: sourceLine.lines,
            vatCategory: sourceLine.vatCategory,
            vat: sourceLine.vat,
            lineAmountWVat: sourceLine.lineAmountWVat,
            charges: sourceLine.charges,
            isMarkedItem: sourceLine.isMarkedItem,
            copyActions: sourceLine.copyActions,
            sellersItemId: sourceLine.sellersItemId,
            buyersItemId: sourceLine.buyersItemId,
        }),
        [],
    );

    function appendItems() {
        if (!value || value <= 0 || !Number.isInteger(value)) {
            return;
        }

        if (lineId >= invoiceLinesHolder.length) {
            handleCloseCallback();
            return;
        }

        const sourceLine =
            lineId === -1 && initialLineData
                ? (initialLineData as InvoiceLine)
                : (invoiceLinesHolder[lineId] as InvoiceLine);

        if (lineId === -1 && invoiceLineChargeData) {
            sourceLine.charges = invoiceLineChargeData;
        }

        if (!sourceLine) {
            handleCloseCallback();
            return;
        }

        const newLines = Array.from({length: value}, () => createDuplicateLine(sourceLine));

        setInvoiceLinesHolder(newLines as InvocieLineHolder[]);

        handleCloseCallback();
    }

    return (
        <Modal title={t('title')} show={isShow} modalWidth={0} onClose={handleCloseCallback}>
            <Input
                type="number"
                label={t('inputLabel')}
                disabled={false}
                placeholder={t('inputPlaceholder')}
                value={value}
                onChange={(e) => setValue(Number(e.target.value))}
            />
            <ButtonWrapper>
                <Button type="button" onClick={handleCloseCallback} variant={ButtonVariant.Outline}>
                    {t('cancel')}
                </Button>
                <Button type="button" variant={ButtonVariant.Normal} onClick={appendItems}>
                    {t('save')}
                </Button>
            </ButtonWrapper>
        </Modal>
    );
};
